import each from 'lodash/each'
import classNames from 'classnames'

import styles from './sidebar.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import library from './library'

function Sidebar(props) {
	const fields = props.fields
	const hideDivider = fields?.hide_divider
	const renderedComponents = []


	each(fields.sidebar, (component, i) => {
		const type = component.acf_fc_layout

		const Component = library[type];

		// For images, exclude the media library 'id' so BlockWrapper can use unique IDs
		let additionalProps = {}
		if (type === 'image' && component.image) {
			const { id, ...imagePropsWithoutId } = component.image
			additionalProps = imagePropsWithoutId
		}

		const renderedComponent = <Component 
			key={`component_${type}_${i}`} 
			fields={component} 
			layout_settings={component.layout_settings}
			fullbleed={false}
			{...additionalProps}
		/>

		renderedComponents.push(renderedComponent)
	})

	return <BlockWrapper {...props} className={styles.sidebar}>
		<ScrollAnimation styles={styles} reverse={true}>
			<div className={classNames(`${styles.sidebar_wrapper} ${hideDivider ? styles.hide_divider : ''}`)}>{renderedComponents}</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default Sidebar